import * as types from './types'
import SendBird from 'sendbird'
import sendbird from './sendbird.js'
import store from '@/store'

export default {
  [types.INIT_SENDBIRD](state, apiId) {
    sendbird.sendbird = new SendBird({
      appId: apiId
    })
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
  },
  [types.SET_SEARCH_TERM_USER](state, text) {
    state.searchTermUser = text
  },
  [types.SET_PAGE_SIZE_USER](state, pageSize) {
    state.pageSizeUser = pageSize
  },
  [types.RESET_CHANNELS](state) {
    state.channels = []
    state.token = ''
    state.searchTerm = ''
  },
  [types.SET_CHANNELS](state, data) {
    if (data !== undefined && data !== null) {
      for (const channel of data.channels) {
        channel.isChecked = false
      }
      state.channels = state.channels.concat(data.channels)
      state.token = data.next
    }
    state.isChannelChecked = false
    state.isChannelNotSaved = false
    let anyChecked = false
    let anyNotSaved = false
    for (const channel of state.channels) {
      if (channel.isChecked) {
        anyChecked = true
        if ((channel.status.includes('Completed') || channel.status === 'Cancelled' || channel.status === 'Voided RO') && parseInt(channel.chatMessageCount) === 0) {
          anyNotSaved = true
        }
      }
    }
    state.isChannelNotSaved = anyNotSaved
    state.isChannelChecked = anyChecked
  },
  [types.SET_CHANNEL_MESSAGE_COUNT](state, data) {
    for (const channel of state.channels) {
      if (channel.name === data.channel) {
        if (channel.chatMessageCount > 0) {
          channel.chatMessageCount += data.count
        } else {
          channel.chatMessageCount = data.count
        }
        break
      }
    }
  },
  [types.SET_CHANNEL_CHECKED](state, data) {
    state.isChannelChecked = false
    state.isChannelNotSaved = false
    for (const channel of state.channels) {
      if (channel.name === data.name) {
        channel.isChecked = data.isChecked
        break
      }
    }
    let anyChecked = false
    let anyNotSaved = false
    for (const channel of state.channels) {
      if (channel.isChecked) {
        anyChecked = true
        if ((channel.status.includes('Completed') || channel.status === 'Cancelled' || channel.status === 'Voided RO') && parseInt(channel.chatMessageCount) === 0) {
          anyNotSaved = true
        }
      }
    }
    state.isChannelNotSaved = anyNotSaved
    state.isChannelChecked = anyChecked
  },
  [types.RESET_USERS](state) {
    state.users = []
    state.tokenUser = ''
    state.searchTermUser = ''
  },
  [types.SET_USERS](state, data) {
    if (data !== undefined && data !== null) {
      for (const user of data.users) {
        user.isChecked = false
      }
      state.users = state.users.concat(data.users)
      state.tokenUser = data.next
      state.isUserChecked = false
      let anyChecked = false
      for (const user of state.users) {
        if (user.isChecked) {
          anyChecked = true
          break
        }
      }
      state.isUserChecked = anyChecked
    }
  },
  [types.SET_USER_CHECKED](state, data) {
    state.isUserChecked = false
    for (const user of state.users) {
      if (user.user_id === data.userId) {
        user.isChecked = data.isChecked
        break
      }
    }
    let anyChecked = false
    for (const user of state.users) {
      if (user.isChecked) {
        anyChecked = true
        break
      }
    }
    state.isUserChecked = anyChecked
  },
  [types.RESET_MESSAGES](state) {
    state.messages = []
  },
  [types.SET_MESSAGE_CHECKED](state, data) {
    console.log('Set Message Checked')
  },
  [types.ADD_MESSAGE](state, message) {
    const userProfile = store.getters['authorize/userProfile']
    const language = store.getters['authorize/language']
    let type = 'received'
    let name = message._sender.nickname
    if (userProfile.email === message._sender.userId) {
      type = 'sent'
      name = 'me'
    }
    let messageText = message.message
    if (message.translations[language] !== undefined && message.translations[language] !== null) {
      messageText = message.translations[language]
    }
    const data = {
      name: name,
      type: type,
      text: messageText,
      avatar: '',
      createdAt: message.createdAt,
      email: message._sender.userId,
      messageId: message.messageId
    }
    state.messages.push(data)
  },
  [types.SET_TYPING](state, channel) {
    state.isTyping = channel.isTyping()
  },
  [types.SET_MESSAGES](state, data) {
    // state.messages = data
  },
  [types.RESET_REQUESTS](state) {
    state.requests = []
    state.token = ''
    state.searchTerm = ''
  },
  [types.SET_REQUESTS](state, data) {
    state.requests = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js